(function () {
  if (window.rvCartProtection) return;
  var queue = Promise.resolve();
  var queued = 0;
  var blocked = false;
  var lastHadProtection = false;
  var rememberedChoice = null;
  var control = '[data-rv-cart-protection]';

  function configuration() {
    var box = document.querySelector(control);
    if (!box) return null;
    var variant = Number(box.dataset.variantId);
    var product = Number(box.dataset.productId);
    if (!Number.isSafeInteger(variant) || variant < 1 || !Number.isSafeInteger(product) || product < 1) return null;
    return { variant: variant, product: product, autoAdd: box.dataset.autoAdd === 'true' };
  }

  function choice(config, value) {
    var key = 'rv-shipping-protection:' + config.product;
    if (arguments.length > 1) {
      rememberedChoice = value;
      try {
        if (value === null) window.sessionStorage.removeItem(key);
        else window.sessionStorage.setItem(key, value);
      } catch (_) {}
      return value;
    }
    try { return window.sessionStorage.getItem(key) || rememberedChoice; } catch (_) { return rememberedChoice; }
  }

  function endpoint(path) {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart' + path;
  }

  async function request(url, body) {
    var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    var response = await fetch(url, options);
    var state = await response.json();
    if (!response.ok || state.errors || state.status >= 400) {
      throw new Error(typeof state.description === 'string' ? state.description :
        typeof state.errors === 'string' ? state.errors : 'Unable to update shipping protection. Please try again.');
    }
    return state;
  }

  async function readCart() {
    var state = await request(endpoint('.js'));
    if (!Array.isArray(state.items)) throw new Error('Unable to check your cart. Please try again.');
    return state;
  }

  function protectionLines(cart, config) {
    return cart.items.filter(function (line) { return Number(line.product_id) === config.product; });
  }

  function merchandiseCount(cart, config) {
    return cart.items.reduce(function (count, line) {
      return count + (Number(line.product_id) === config.product ? 0 : line.quantity);
    }, 0);
  }

  function plan(cart, config, selected) {
    var lines = protectionLines(cart, config);
    var keep = selected && merchandiseCount(cart, config) > 0;
    var updates = {};
    lines.forEach(function (line, index) {
      var quantity = keep && index === 0 ? 1 : 0;
      if (line.quantity !== quantity) updates[line.key] = quantity;
    });
    return { updates: updates, add: keep && lines.length === 0 };
  }

  function sectionsToRender() {
    var sections = [];
    if (document.querySelector('cart-drawer')) sections.push({ id: 'cart-drawer', target: 'cart-drawer', selector: '#CartDrawer' });
    if (document.getElementById('cart-icon-bubble')) sections.push({ id: 'cart-icon-bubble', target: '#cart-icon-bubble', selector: '.shopify-section' });
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var element = document.getElementById(id);
      if (element && element.dataset.id) sections.push({ id: element.dataset.id, target: '#' + id, selector: '#' + id });
    });
    return sections;
  }

  async function render(cart, sections) {
    if (!sections.length) return;
    if (!cart.sections || sections.some(function (section) { return !cart.sections[section.id]; })) {
      var url = new URL(endpoint(''), window.location.href);
      url.searchParams.set('sections', sections.map(function (section) { return section.id; }).join(','));
      cart.sections = await request(url.toString());
    }
    var replacements = sections.map(function (section) {
      var html = cart.sections[section.id];
      if (!html) throw new Error('Your cart changed. Please reload the page to see the correct total.');
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (!source) throw new Error('Your cart changed. Please reload the page to see the correct total.');
      return { section: section, source: source };
    });
    replacements.forEach(function (replacement) {
      var section = replacement.section;
      var target = document.querySelector(section.target);
      if (!target) return;
      if (section.id === 'cart-drawer') {
        var inner = target.querySelector('#CartDrawer');
        if (inner) inner.innerHTML = replacement.source.innerHTML;
        target.classList.toggle('is-empty', cart.item_count === 0);
        var overlay = target.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof target.close === 'function') overlay.addEventListener('click', target.close.bind(target));
      } else {
        target.innerHTML = replacement.source.innerHTML;
        if (section.target !== '#cart-icon-bubble') target.classList.toggle('is-empty', cart.item_count === 0);
      }
    });
  }

  function updateControls(cart, config) {
    var added = protectionLines(cart, config).length > 0;
    var merchandise = merchandiseCount(cart, config);
    document.querySelectorAll(control).forEach(function (box) {
      box.hidden = merchandise === 0;
      box.classList.toggle('is-selected', added);
      var input = box.querySelector('.rv-cart-protect__toggle');
      if (input) input.checked = added;
      var state = box.querySelector('.rv-cart-protect__state');
      if (state) state.textContent = added ? box.dataset.addedText : box.dataset.removedText;
    });
    lastHadProtection = added;
  }

  function setBusy() {
    document.documentElement.toggleAttribute('data-rv-protection-pending', queued > 0);
    document.documentElement.toggleAttribute('data-rv-protection-blocked', blocked);
    document.querySelectorAll('.rv-cart-protect__toggle').forEach(function (input) { input.disabled = queued > 0; });
    document.querySelectorAll(control).forEach(function (box) { box.setAttribute('aria-busy', queued > 0 ? 'true' : 'false'); });
  }

  function showError(message) {
    document.querySelectorAll('.rv-cart-protect__error').forEach(function (error) {
      error.textContent = message;
      error.hidden = !message;
    });
    if (message) {
      ['cart-errors', 'CartDrawer-CartErrors'].forEach(function (id) {
        var error = document.getElementById(id);
        if (error) error.textContent = message;
      });
    }
  }

  async function synchronize(config, options) {
    for (var wait = 0; document.querySelector('.cart__items--disabled') && wait < 100; wait += 1) {
      await new Promise(function (resolve) { setTimeout(resolve, 50); });
    }
    if (document.querySelector('.cart__items--disabled')) throw new Error('Your cart is still updating. Please try again.');
    var cart = await readCart();
    var merchandise = merchandiseCount(cart, config);
    var lines = protectionLines(cart, config);
    if (!merchandise) choice(config, null);
    if (options.nativeRemoval && lastHadProtection && !lines.length && merchandise) choice(config, 'declined');
    var selected = options.selected;
    if (typeof selected === 'boolean' && merchandise) choice(config, selected ? 'accepted' : 'declined');
    if (typeof selected !== 'boolean') {
      selected = choice(config) !== 'declined' && (lines.length > 0 || config.autoAdd);
    }
    var change = plan(cart, config, selected);
    var sections = sectionsToRender();
    var common = { sections: sections.map(function (section) { return section.id; }), sections_url: window.location.pathname };
    var mutated = false;
    if (change.add) {
      var added = await request(endpoint('/add.js'), Object.assign({}, common, { items: [{ id: config.variant, quantity: 1 }] }));
      mutated = true;
      cart = await readCart();
      cart.sections = added.sections;
    } else if (Object.keys(change.updates).length) {
      cart = await request(endpoint('/update.js'), Object.assign({}, common, { updates: change.updates }));
      mutated = true;
    }
    var cleanup = plan(cart, config, selected);
    if (Object.keys(cleanup.updates).length) {
      cart = await request(endpoint('/update.js'), Object.assign({}, common, { updates: cleanup.updates }));
      mutated = true;
    }
    updateControls(cart, config);
    if (mutated || blocked) await render(cart, sections);
    updateControls(cart, config);
    blocked = false;
    showError('');
    return cart;
  }

  function reconcile(options) {
    var config = configuration();
    if (!config) return Promise.resolve();
    queued += 1;
    setBusy();
    var result = queue.then(function () { return synchronize(config, options || {}); }).catch(async function (error) {
      blocked = true;
      try { updateControls(await readCart(), config); } catch (_) {}
      showError(error.message);
    }).finally(function () {
      queued -= 1;
      setBusy();
    });
    queue = result;
    return result;
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('.rv-cart-protect__toggle')) return;
    if (queued) { input.checked = !input.checked; return; }
    reconcile({ selected: input.checked });
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (queued && input.matches && input.matches('.quantity__input') && input.closest('cart-items, cart-drawer-items')) {
      input.value = input.getAttribute('value');
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var cartAction = target.closest('cart-remove-button, quantity-input');
    var checkout = target.closest('[name="checkout"], .cart__dynamic-checkout-buttons, .rv-cart-wallets, a[href*="/checkout"]');
    if ((queued && cartAction) || ((queued || blocked) && checkout)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (blocked && !queued) reconcile();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if ((queued || blocked) && (event.target.id === 'cart' || event.target.id === 'CartDrawer-Form')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (blocked && !queued) reconcile();
    }
  }, true);

  function initialize() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        return reconcile({ nativeRemoval: event.source === 'cart-items' });
      });
    }
    reconcile();
  }

  window.rvCartProtection = { reconcile: reconcile, whenIdle: function () { return queue; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
